import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { WaybillIdView } from '../../../../models/shipment-id-view.model';
import { Observable } from 'rxjs';
import { ShipmentWaybillEndpoint } from '../../constants';
import { WaybillEquipmentsModel } from '../../../../models/waybill-equipments.model';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillEquipmentsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentWaybillTransportEquipments(waybillIdView: WaybillIdView): Observable<WaybillEquipmentsModel> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.Equipments
    }?${getQueryStringFromObject({
      ...waybillIdView,
    })}`;

    return this.http.get<WaybillEquipmentsModel>(url);
  }
}
